import type { ProjectFile } from '@/api/client';

/** Файл загружен не более чем 48 часов назад */
export function isRecentlyUploaded(uploadedAt: string | undefined): boolean {
  if (!uploadedAt) return false;
  try {
    const uploaded = new Date(uploadedAt).getTime();
    const now = Date.now();
    return (now - uploaded) / (1000 * 60 * 60) < 48;
  } catch {
    return false;
  }
}

/** Количество «новых» файлов (загружены за последние 48 ч) */
export function countNewFiles(files: ProjectFile[] | undefined): number {
  if (!files?.length) return 0;
  return files.filter((f) => isRecentlyUploaded(f.uploaded_at)).length;
}
